<template>

    <div class="tw-flex tw-w-full tw-border-b tw-border-dark-grey tw-py-3">
        <span class="tw-text-sm tw-font-normal tw-uppercase tw-w-1/5">{{ text }}</span>
        <span class="tw-w-4/5" v-if="should_be_linked"><a :href="link_location" target="_blank" class="text-decoration-underline">{{ value_string }}</a></span>
        <span class="tw-w-4/5" v-else>{{ value_string }}</span>
    </div>

</template>

<script>
    export default {
        name: "CrewAlertInfoItem",
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'text': {
                type: String,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'value': {
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        computed: {
            value_array() {
                return Array.isArray(this.value) ? this.value : [this.value]
            },
            value_string() {
                if (!Array.isArray(this.value_array)) {
                    return null
                }
                switch (this.text) {
                    case 'Call Sheet':
                        return this.value || this.constants?.CALL_SHEET_STATUSES?.CALL_SHEET_STATUS_TO_FOLLOW
                    default:
                        return this.value_array.join(', ')
                }

            },
            link_location() {
                switch (this.text){
                    case 'Call Sheet':
                        let id = this.$parent?.crew_alert?.id
                        let filename = this.$parent?.crew_alert?.call_sheet_file
                        return `/storage/crewalerts/${id}/${filename}`
                    case 'Phone':
                        let phone = this.$parent?.crew_alert?.phone
                        return `tel:${this.$root.formatPhoneNumeric(phone)}`
                    case 'Email':
                        let email = this.$parent?.crew_alert?.email
                        return `mailto:${email}`
                    default:
                        return this.value_string
                }
            },
            should_be_linked() {
                let types_to_link = ['Call Sheet', 'Phone', 'Email']
                let match_by_type = types_to_link.includes(this.text)
                let exclude_when = (this.text === 'Call Sheet' && (this.value_string === this.constants?.CALL_SHEET_STATUSES?.CALL_SHEET_STATUS_TO_FOLLOW || this.$parent?.is_preview))
                return match_by_type && !exclude_when
            }
        },
        methods: {
            profileInfoForArrays(data_array, prop_name) {
                if (!data_array || !Array.isArray(data_array) || (Array.isArray(data_array) && data_array.length === 0)) return null
                return data_array.map(element => element[prop_name]).filter(element=>element)
            }
        }
    }
</script>

<style>
</style>
